"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAR_POINT = exports.OFF_POINT = exports.BLACK = exports.WHITE = void 0;
// single firebase document per game
exports.WHITE = 0;
exports.BLACK = 1;
exports.OFF_POINT = 0;
exports.BAR_POINT = 25;
